var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24-px-Icons",
    transform: "translate(-219.000000, -26.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_back",
    transform: "translate(216.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) ",
    id: "forward"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 3.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9 L16,9",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,9 L7.93774223,0.937742233",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,9 L7.93774223,17.0622578",
    id: "Line"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cec08cf878a4c8cf22aca7e4c44703db.svg";
export { ForwardRef as ReactComponent };